import { createElement } from "/elements_functions/new_elements.js";
import { makeNewButton } from "/buttons_functions/custom_button_functions.js";
import { createPlaque } from "/plaque/create_plaque.js";

export function insertPlaqueAndAlertWindow(text, exit=true) {

    const plaque = createPlaque();

    isnertAlertWindowIntoExistingPlaque(plaque, text, exit);

    return plaque;
}

export function isnertAlertWindowIntoExistingPlaque(plaque, text, exit=true) {

    const alertWindow = createElement('div', 'alert-window', null);
    const alertWindowText = createElement('p', null, null);
    alertWindowText.innerText = text;

    const alertWindowButton = createElement('button', null, null);
    makeNewButton(alertWindowButton, 'light-black', 'white', 'Alright', 'lighten');
    alertWindowButton.addEventListener('click', () => plaque.remove());

    alertWindow.append(alertWindowText, alertWindowButton);

    plaque.append(alertWindow);

    if(exit===true) {
        plaque.addEventListener('click', (e) => {
            if(e.target===plaque)
                plaque.remove();
        })
    }

    alertWindow.alertWindowText = alertWindowText;
    alertWindow.alertWindowButton = alertWindowButton;

    alertWindow.appendToCenter = (element) => {
        const buttonRemoved = !alertWindow.contains(alertWindowButton);

        if(buttonRemoved)
            alertWindow.append(element);
        else
            alertWindowButton.insertAdjacentElement('beforebegin', element);
    }

    plaque.alertWindow = alertWindow;

    return plaque;

}